import { render, staticRenderFns } from "./DotPlot.vue?vue&type=template&id=0b290668&scoped=true&"
import script from "./DotPlot.vue?vue&type=script&lang=js&"
export * from "./DotPlot.vue?vue&type=script&lang=js&"
import style0 from "./DotPlot.vue?vue&type=style&index=0&id=0b290668&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b290668",
  null
  
)

export default component.exports